import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-x-snapshot",
  "use": "app-icon-x-snapshot-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-x-snapshot\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><g transform=\"translate(3 3.5)\" stroke=\"#6C7280\" stroke-width=\"1.5\"><path d=\"M18 16.759H0V2.579h3.857L5.143 0h7.714l1.286 2.578H18z\" /><circle cx=\"9.31\" cy=\"9.31\" r=\"3.724\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol